/* src/app/modules/concept/conceptfamily/conceptfamily.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
.cff-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.cff-dlg-title {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px 10px !important;
}
.cff-dlg-title__left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
}
.cff-dlg-title__icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cff-dlg-title__icon mat-icon {
  font-size: 19px;
  width: 19px;
  height: 19px;
  color: var(--cf-brand, #e3fd64);
}
.cff-dlg-content {
  padding: 0 20px 8px !important;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cff-section {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 10px;
  overflow: hidden;
}
.cff-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.cff-section__head mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.cff-section__body {
  padding: 12px;
  background: var(--cf-surface, #fff);
  display: flex;
  flex-direction: column;
  gap: 0;
}
.cff-toggle {
  margin: 6px 0 10px;
}
.cff-image-preview {
  margin-bottom: 10px;
  text-align: center;
}
.cff-image-preview__img {
  max-width: 100%;
  max-height: 180px;
  border-radius: 6px;
  border: 1px solid var(--cf-border, #e5e7eb);
}
.cff-file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.cff-file-hidden {
  display: none;
}
.cff-file-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  background: #fff;
  color: var(--cf-text, #1a1d23);
  transition: border-color 0.15s;
}
.cff-file-btn:hover {
  border-color: var(--cf-brand, #e3fd64);
}
.cff-file-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cff-file-delete {
  border-radius: 6px !important;
  color: #dc2626 !important;
  border-color: #dc2626 !important;
}
.cff-dlg-actions {
  padding: 8px 20px 14px !important;
  gap: 8px;
}
.cff-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
}
.cff-btn-save:hover {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
::ng-deep .cff-dlg-content .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .cff-dlg-content .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
/*# sourceMappingURL=conceptfamily.component.css.map */
